var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueReqBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F0F5FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7583 24.2513L21.0083 25.5013L24.3416 22.168",
    stroke: "#3A80E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3332 17.0013H23.6665C25.3332 17.0013 25.3332 16.168 25.3332 15.3346C25.3332 13.668 24.4998 13.668 23.6665 13.668H20.3332C19.4998 13.668 18.6665 13.668 18.6665 15.3346C18.6665 17.0013 19.4998 17.0013 20.3332 17.0013Z",
    stroke: "#3A80E2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 15.3516C28.1083 15.5016 29.5 16.5266 29.5 20.3349V25.3349C29.5 28.6682 28.6667 30.3349 24.5 30.3349H19.5C15.3333 30.3349 14.5 28.6682 14.5 25.3349V20.3349C14.5 16.5349 15.8917 15.5016 18.6667 15.3516",
    stroke: "#3A80E2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueReqBg);
export default __webpack_public_path__ + "static/media/blueReqBg.e35b645485de6baab19b8942316117d0.svg";
export { ForwardRef as ReactComponent };